<template>
      <div class="warpImgEl">
        <el-upload
              :action="httpUrl"
              :headers="headers"
              list-type="picture-card"
              :limit="limit*1"                 
              :on-preview="showBtn"
              :before-upload="UploadLimitBtn"
              :on-remove="handleRemove"
              :on-success="uploadImg" 
              :file-list="defaultImgHttp"
              >
              <i class="el-icon-plus"></i>
          </el-upload>
          <div v-if="showMark" class="mark">尺寸:{{width}}×{{height}}像素；大小：{{size}}M以内；格式{{rules}}</div>
          <el-dialog :visible.sync="dialogVisible" :modal="false">
              <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </div>
</template>
<script>
  import {url,api} from '@/utils/config'
  export default {
    data:()=>({
        httpUrl:"",   //请求的url
        headers:{},   //请求头部
        defaultImgHttp:[],
        updateImgVal:[],   
        dialogImageUrl: '', //预览的图片路径
        dialogVisible: false
    }),

   created(){
      this.setParm() 
   },

    props:{
        showMark:{
          type: Boolean,
          default:true,  
        },
        limit:{           //限制图片上传的张数
          type: String,
          default: "1",  
        },
        keyVal:{         //关键字
          type: String,
          default: "",
        },
        width:{          //上传的图片宽度      
           type: String,
           default: "0",
        },
        height:{         //上传图片的高度
           type: String,
           default: "0",
        },
        size:{           //上传图片的大小
           type: String,
           default: "3", 
        },
        rules:{
           type: String,
           default: "jpg、gif、png", 
        },

    },
    methods:{ 
      //设置初始化的值
      setParm(){
         this.headers={'Authorization':localStorage.getItem("YunWeiTikenBRJ")}
         this.httpUrl = url.UPLOADINGMO
      },
 
      //上传文件前的出发事件
      UploadLimitBtn(files){
         const isJPG =  files.type === 'image/jpeg' ||  files.type === 'image/png' || files.type === 'image/gif' ;
         const isLt2M = files.size / 1024 / 1024 < this.size;

         if (!isJPG) {
            this.$message.error('上传图片只能是'+this.rules+'格式!');
         }
         if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 '+this.size+'MB!');
         }

         !!this.$emit('before-upload',files) && this.$emit('before-upload',files);

         return isJPG && isLt2M;
      }, 

      //上传图片后获取数据
      uploadImg(response, files, fileList){
         this.updateImgVal = [...this.updateImgVal,...response.data]
         let parms = {
               key:this.keyVal,
               val:this.updateImgVal
         }
         this.$emit('getUpload',parms)
      },

      //预览图片
      showBtn(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
      },

      //删除图片后获取数据
      handleRemove(file,fileList){
         if(!file.response){
            let url = file.url
            let valList = this.updateImgVal
            for(var i in valList){
               if(url.indexOf(valList[i])!=-1){
                  this.updateImgVal.splice(i,1) 
                  break
               }
            }
         }else{
            let ImgName = file.response.data[0]
            this.updateImgVal.splice(this.updateImgVal.indexOf(ImgName),1)
         }
         let parms = {
                  key:this.keyVal,
                  val:this.updateImgVal
            }
         this.$emit('getUpload',parms)
      },
      
      //设置默认值
      setVal(parms){
         this.defaultImgHttp = parms.defaultVal
         this.updateImgVal = parms.defaultImg
      }
    }
  }
</script>
<style lang="scss" scoped>
   .warpImgEl{
     ::v-deep .el-upload-list--picture-card .el-upload-list__item,::v-deep .el-upload--picture-card{
        width:80px;
        height:80px;
        display: block;
        margin: 0 8px 0 0;
     }
     ::v-deep .el-upload--picture-card i{
        position: relative;
        bottom: 28px;   
     }
   }
   .warpImgEl>div{
      display: flex;
   }
   .mark{
      color: red;
      padding-top:0px;
      line-height:20px;
      font-size: 12px;
   }
</style>